import styled from 'styled-components'

export default styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 30px;
  z-index: 9999;
  background-color: ${({ theme }) => theme.background || '#ffffff'};
  border-top: 2px solid ${({ theme }) => theme.primary || '#007bff'};
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
`
